import { C3Type } from '../add/types';

export function toForm(
  {content_title,
content_vtr_id,
person_name,
person_vtr_id,
role,
source,
source_links,
sub_role,}: C3Type
) {
  return {
    content_title,
content_vtr_id,
person_name,
person_vtr_id,
role,
source,
source_links,
sub_role
  }
}